"use client";
import { css as o } from "@emotion/react";
import { MEDIA_QUERIES as n } from "../../../tokens/media-queries/MediaQueries.js";
import { SPACINGS as r } from "../../../tokens/spacings/Spacings.js";
const $ = (d) => {
  const e = d ? `padding-${d}` : "padding";
  return o`
		${e}: ${r.md};

		@media screen and (${n.tablet}) {
			${e}: ${r.xl};
		}

		@media screen and (${n.widescreen}) {
			${e}: ${r.xxl};
		}
	`;
};
export {
  $ as boxPadding
};
